



































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import appService from "@/services/appService";
import BlurredTenant from '@/components/BlurredTenant.vue';

export default Vue.extend({
  components: { BlurredTenant },
  data() {
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      self: this,
      chargingStation: null,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "startTime",
          "sort-desc": true,
          "class": "charging-sessions-table",
          "item-class": this.getRowClass, // Add row class function
        },
        content: {
          name: "Charging Sessions",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("tenants", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              userId: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "retailer"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "User",
                  required: true,
                  "item-value": "_id",
                  "item-text": "email",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "email",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              retailerId: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Retailer",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("retailers", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              chargerVendorId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Charger Vendor",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("chargerVendors", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              "chargingStationSnapshot.serialNumber": {
                attrs: {
                  label: "Serial Number",
                },
                rules: {
                  match: {},
                },
              },
              "chargingStationSnapshot.uniqueId": {
                attrs: {
                  label: "Charge Point ID",
                },
                rules: {
                  match: {},
                },
              },
              connectorId: {
                attrs: {
                  label: "Connector ID",
                },
                rules: {
                  equal_to: {},
                },
              },
              "details._id": {
                type: "integer",
                attrs: {
                  label: "Transaction ID",
                },
                rules: {
                  equal_to: {},
                },
              },
              ...(userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                transactionID: {
                  type: "text",
                  attrs: {
                    label: "Invoice Code",
                  },
                  rules: {
                    includes: {},
                  },
                },
              }),
              "details.tagID": {
                attrs: {
                  label: "ID Tag",
                },
                rules: {
                  match: {},
                },
              },
              startTime: {
                type: "XTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Start Time (From)",
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Start Time (To)",
                    },
                  },
                },
              },
              ocpi: {
                type: "select",
                attrs: {
                  label: "OCPI",
                  items: [
                    { text: "All", value: "" },
                    { text: "Yes", value: "true" },
                    { text: "No", value: "false" }
                  ]
                },
                rules: {
                  equal_to: {},
                },
              },
              ocpiData: {
                type: "select",
                attrs: {
                  label: "OCPI Data",
                  items: [
                    { text: "All", value: "undefined" },
                    { text: "Has Data", value: "not_null" },
                    { text: "No Data", value: "null" }
                  ]
                },
                rules: {
                  custom: {
                    attrs: {
                      label: "OCPI Data Status",
                    },
                  },
                },
              },
              stopTime: {
                type: "XTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "End Time (From)",
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "End Time (To)",
                    },
                  },
                },
              },
            },
          },
          displayFields: {
            "details._id": {
              text: "Transaction ID",
              options: {
                subProp: "details._id",
                sortBy: "details._id",
              },
            },
            startTime: {
              text: "Start Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            stopTime: {
              text: "End Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            uniqueId: {
              text: "Charging Station",
              options: {
                subProp: "chargingStationSnapshot.uniqueId",
                sortBy: "chargingStationSnapshot.uniqueId",
              },
            },
            user: {
              text: "User",
              options: {
                subProp: "userSnapshot.email",
                label: true,
                sortBy: "userId",
              },
            },
            rfid: {
              text: "RFID",
              options: {
                subProp: "tagSnapshot.value"
              },
            },
            vin: {
              text: "Vin",
              options: {
                subProp: "carSnapshot.vin"
              },
            },
            pointOrigin: {
              text: "Before Discount",
              options: {
                preTransform(value) {
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            point: {
              text: "After Discount",
              options: {
                preTransform(value) {
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            pointPromotion: {
              text: "Use Promotion",
              options: {
                preTransform(value) {
                  if (!value) { return 0 }
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            ...(userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
              transactionID: {
                text: "Invoice Code",
                options: {
                  subProp: "transactionID",
                  sortBy: "transactionID",
                },
              },
            }),
            retailer: {
              text: "Retailer",
              options: {
                subProp: "retailerSnapshot.name",
                label: true,
                sortBy: "retailerId",
              },
            },
            chargerVendor: {
              text: "Charger Vendor",
              options: {
                subProp: "chargerVendorSnapshot.name",
                label: true,
                sortBy: "chargerVendorId",
              },
            },
            serialNumber: {
              text: "Serial Number",
              options: {
                subProp: "chargingStationSnapshot.serialNumber",
                sortBy: "chargingStationSnapshot.serialNumber",
              },
            },
            connectorId: {
              text: "Connector ID",
              sortable: true,
            },
            duration: {
              text: "Duration (minutes)",
              sortable: true,
              options: {
                subProp: "details.stop.totalDurationSecs",
                preTransform(value) {
                  return (value || 0) * 1000;
                },
                filter: "duration",
                sortBy: "details.stop.totalDurationSecs",
              },
            },
            meterStart: {
              text: "Meter Start (Wh)"
            },
            meterStop: {
              text: "Meter Stop (Wh)",
              options: {
                subProp: "details.stop.meterStop",
                preTransform(value) {
                  return (value || 0);
                },
                sortBy: "details.stop.meterStop",
                filter: "number3",
              },
            },
            energyDelivered: {
              text: "Energy Delivered (kWh)",
              sortable: true,
              options: {
                subProp: "details.stop.totalConsumptionWh",
                preTransform(value) {
                  return (value || 0) / 1000;
                },
                filter: "number3",
                sortBy: "details.stop.totalConsumptionWh",
              },
            },
            "soc": {
              text: "SoC",
            },
            "voltage": {
              text: "Voltage",
            },
            "powerActiveImport": {
              text: "Power.Active.Import (W)",
            },
            "currentImport": {
              text: "Current.Import (A)",
            },
            ocpi: {
              text: "OCPI",
              sortable: true,
              options: {
                preTransform(value) {
                  return value ? "Yes" : "No";
                },
                filter: "text",
                sortBy: "ocpi",
              },
            },
            ocpiData: {
              text: "OCPI Data",
              sortable: true,
              options: {
                preTransform(value) {
                  return value && value !== null && value !== '' ? "Has Data" : "No Data";
                },
                filter: "text",
                sortBy: "ocpiData",
              },
            },
            tenant: userManager.checkRole(["systemAdmin", "admin", "cpoGroup"]) && {
              text: "Organization",
              options: {
                subProp: "tenant.name",
                label: true,
                sortBy: "tenantId",
              },
            },
          },
          multiSelectActionButtons: {
            export: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "retailer"]) && {
              content: {
                text: "Export selected",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  coreApiClient.download("chargingSessions", `@/export`, {
                    payload: JSON.stringify({
                      filters: [
                        {
                          key: "_id",
                          operator: "in",
                          value: dataTable.model.value.map((item) => item._id),
                        },
                      ],
                      limit: -1,
                      extraParams: {
                        currentTimeZoneOffset: new Date().getTimezoneOffset() * -1 * 60 * 1000,
                      },
                    }),
                  });
                },
              },
            },
          },
          topActionButtons: {
            export: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "retailer"]) && {
              content: {
                text: "Export all",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  coreApiClient.download("chargingSessions", `@/export`, dataTable.getFindAllOptions());
                },
              },
            },
          },
          findAllOptionsFilter(options) {
            const activeTenant = appService.getActiveTenant();
            if (activeTenant) {
              options.filters.push({
                key: "tenantId",
                operator: "equal_to",
                value: activeTenant._id,
              });
            }

            const { $route } = this.context();
            if ($route.query.chargingStationId) {
              options.filters.push({
                key: "chargingStationId",
                operator: "equal_to",
                value: $route.query.chargingStationId,
              });
            }

            options.filters.push({
              key: "deviceType",
              operator: "not_equal_to",
              value: 'smartsocket',
            });

            // Handle OCPI filter
            const ocpiFilter = options.filters.find(f => f.key === 'ocpi');
            if (ocpiFilter && ocpiFilter.value) {
              if (ocpiFilter.value === 'true') {
                ocpiFilter.operator = 'equal_to';
                ocpiFilter.value = true;
              } else if (ocpiFilter.value === 'false') {
                ocpiFilter.operator = 'equal_to';
                ocpiFilter.value = false;
              }
            } else if (ocpiFilter && !ocpiFilter.value) {
              // Remove filter if no value selected
              options.filters = options.filters.filter(f => f.key !== 'ocpi');
            }

            // Handle OCPI Data filter
            const ocpiDataFilter = options.filters.find(f => f.key === 'ocpiData');
            if (ocpiDataFilter && ocpiDataFilter.value) {
              if (ocpiDataFilter.value === 'not_null') {
                ocpiDataFilter.operator = 'not_equal_to';
                ocpiDataFilter.value = null;
              } else if (ocpiDataFilter.value === 'null') {
                ocpiDataFilter.operator = 'equal_to';
                ocpiDataFilter.value = null;
              }
            } else if (ocpiDataFilter && !ocpiDataFilter.value) {
              // Remove filter if no value selected
              options.filters = options.filters.filter(f => f.key !== 'ocpiData');
            }

            options.extraParams.currentTimeZoneOffset = new Date().getTimezoneOffset() * -1 * 60 * 1000;

            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("chargingSessions", "findAll", options);
              return [items, count];
            },
          },
        },
      },
    };
  },
  methods: {
    getRowClass(item) {
      // Debug logging to check item data
      console.log('getRowClass called for item:', item);
      console.log('item.ocpi:', item.ocpi);
      console.log('item.ocpiData:', item.ocpiData);
      
      // Check if item has both ocpi and ocpiData (not null, not empty string, not undefined)
      if (item.ocpi && item.ocpiData && item.ocpiData !== null && item.ocpiData !== '' && item.ocpiData !== undefined) {
        console.log('Returning blue class for item:', item._id);
        return 'charging-session-row-blue';
      } 
      // Check if item has only ocpi but no ocpiData
      else if (item.ocpi && (item.ocpiData === null || item.ocpiData === '' || item.ocpiData === undefined)) {
        console.log('Returning yellow class for item:', item._id);
        return 'charging-session-row-yellow';
      }
      
      console.log('No class returned for item:', item._id);
      return '';
    }
  },
  async created() {
    const $route = this.$route;
    if ($route.query.chargingStationId) {
      const chargingStation = await coreApiClient.call("chargingStations", "findById", {
        id: $route.query.chargingStationId,
      });
      this.chargingStation = chargingStation;
    }
  },
});
